import { Component, OnInit } from '@angular/core';
import { Ng1LiveChatService } from '../../shared/ng1/ng1-live-chat.service';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { CalendlyService } from '../../config/calendly.service';

@Component({
  selector: 'cc-start-actions',
  templateUrl: './start-actions.component.html',
  styleUrls: ['./start-actions.component.scss']
})
export class StartActionsComponent implements OnInit {
  constructor(
    private liveChatService: Ng1LiveChatService,
    private amplitudeService: AmplitudeService,
    private calendly: CalendlyService
  ) {}

  ngOnInit() {}

  startChat() {
    this.amplitudeService.logEvent('Panel:Onboarding: Start a chat clicked');
    this.liveChatService.contactSupport();
  }

  scheduleDemo() {
    this.amplitudeService.logEvent('Panel:Onboarding: Schedule a demo clicked');
    this.calendly.openCalendly();
  }
}
